// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section{
  margin: 63px 0;
  background: var(--color-primary-white);
  
}

section .styles_container__w5Pmn{
  margin: 0px auto;

}
.styles_container__w5Pmn{
  width: var(--container-width-md);
  max-width: 1920px;
  margin-inline: auto ;
  display: flex;
  flex-direction: column;
}

.styles_container__w5Pmn  h2{
  margin-top: 27px;
  text-align: center;
}

.styles_container__w5Pmn > ul{
  display: grid;
  grid-template-columns: repeat(auto-fit,minmax(450px,1fr));
  column-gap: 200px;
  row-gap: 96px;
}

.styles_card__x9YMN{
  width: 440px;
  list-style: none;
  margin: auto;
  background:var(--color-primary-white);
}
.styles_card__x9YMN > figure > img{
  margin: auto;
  width: 244px;
  height: 182px;
  object-fit:contain;
}

.styles_card__x9YMN > figure > figcaption{
  margin: 20px 0;
  text-align: center;
  font-style: normal;
  font-weight: 450;
  font-size: 25px;
  line-height: 36px;
}

.styles_card__x9YMN > div > ul {
  list-style: none;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  font-style: normal;
  font-weight: 390;
  font-size: 22px;
  line-height: 31px;
}

.styles_card__x9YMN > a {
  font-style: normal;
  font-weight: 420;
  font-size: 22px;
  line-height: 31px;
  cursor: pointer;
}

@media screen and (max-width: 820px ){

  .styles_container__w5Pmn > ul{
    display: grid;
    grid-template-columns: repeat(auto-fit,minmax(clamp(300px,10vw,440px),1fr));
    column-gap: 200px;
    row-gap: 96px;
  }

  .styles_card__x9YMN{
    width: clamp(300px,10vw,440px);
   
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Cards/styles.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,sCAAsC;;AAExC;;AAEA;EACE,gBAAgB;;AAElB;AACA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;AACvC;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE;IACE,aAAa;IACb,2EAA2E;IAC3E,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,8BAA8B;;EAEhC;AACF","sourcesContent":["section{\n  margin: 63px 0;\n  background: var(--color-primary-white);\n  \n}\n\nsection .container{\n  margin: 0px auto;\n\n}\n.container{\n  width: var(--container-width-md);\n  max-width: 1920px;\n  margin-inline: auto ;\n  display: flex;\n  flex-direction: column;\n}\n\n.container  h2{\n  margin-top: 27px;\n  text-align: center;\n}\n\n.container > ul{\n  display: grid;\n  grid-template-columns: repeat(auto-fit,minmax(450px,1fr));\n  column-gap: 200px;\n  row-gap: 96px;\n}\n\n.card{\n  width: 440px;\n  list-style: none;\n  margin: auto;\n  background:var(--color-primary-white);\n}\n.card > figure > img{\n  margin: auto;\n  width: 244px;\n  height: 182px;\n  object-fit:contain;\n}\n\n.card > figure > figcaption{\n  margin: 20px 0;\n  text-align: center;\n  font-style: normal;\n  font-weight: 450;\n  font-size: 25px;\n  line-height: 36px;\n}\n\n.card > div > ul {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  row-gap: 10px;\n  font-style: normal;\n  font-weight: 390;\n  font-size: 22px;\n  line-height: 31px;\n}\n\n.card > a {\n  font-style: normal;\n  font-weight: 420;\n  font-size: 22px;\n  line-height: 31px;\n  cursor: pointer;\n}\n\n@media screen and (max-width: 820px ){\n\n  .container > ul{\n    display: grid;\n    grid-template-columns: repeat(auto-fit,minmax(clamp(300px,10vw,440px),1fr));\n    column-gap: 200px;\n    row-gap: 96px;\n  }\n\n  .card{\n    width: clamp(300px,10vw,440px);\n   \n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__w5Pmn`,
	"card": `styles_card__x9YMN`
};
export default ___CSS_LOADER_EXPORT___;
